import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]

import { computed } from 'vue'
import { mirrorWatchers, mirrorBoard, marksVersion, mirrorMarksHidden, setMirrorMarksHidden } from '@/composables/useScreenMirror'


export default /*@__PURE__*/_defineComponent({
  __name: 'ScreenMirrorIndicator',
  setup(__props) {

// Aviso ao agente enquanto um supervisor assiste a tela dele pelo Espelho ao vivo (transparência — LGPD).
const names = computed(() => mirrorWatchers.value.join(', '))
// marksVersion: recalcula quando chega/sai marcação (o quadro em si não é reativo).
const hasMarks = computed(() => {
  void marksVersion.value
  return mirrorBoard.marks.size > 0
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "smi-fade" }, {
    default: _withCtx(() => [
      (_unref(mirrorWatchers).length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "smi",
            role: "status",
            title: `Espelho ao vivo: ${names.value} está vendo esta tela do sistema`
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "smi-dot" }, null, -1)),
            _cache[3] || (_cache[3] = _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
              _createElementVNode("circle", {
                cx: "12",
                cy: "12",
                r: "3"
              })
            ], -1)),
            _createElementVNode("span", null, [
              _cache[1] || (_cache[1] = _createTextVNode("Sua tela está sendo vista por ", -1)),
              _createElementVNode("strong", null, _toDisplayString(names.value), 1),
              (hasMarks.value && !_unref(mirrorMarksHidden))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" · está marcando sua tela")
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            (hasMarks.value || _unref(mirrorMarksHidden))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "smi-btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(setMirrorMarksHidden)(!_unref(mirrorMarksHidden))))
                }, _toDisplayString(_unref(mirrorMarksHidden) ? 'Mostrar marcações' : 'Esconder marcações'), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})